import {
  PsychicCategoryQueryType,
  QueryParamToRequestParamMap,
  SortingQueryValue,
} from './types';

export const subjectQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  love: 'Love/relationships',
  career: 'Career/work',
  destiny: 'Destiny/life path',
  money: 'Money/finance',
  pet: 'Pets/animals',
  past_life: 'Past lives',
  deceased_loved_one: 'Deceased loved ones',
  lost_object: 'Lost objects',
  lost_people_pet: 'Lost people/pets',
};

export const abilityQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  empath: 'Empath',
  medium: 'Medium',
  clairvoyant: 'Clairvoyant',
  clairaudient: 'Clairaudient',
  clairsentient: 'Clairsentient',
  dream_analyst: 'Dream analyst',
  remote_viewing: 'Remote viewing',
  channeling: 'Channeling',
  automatic_writing: 'Automatic writing',
};

export const styleQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  inspirational: 'Inspirational',
  compassionate: 'Compassionate',
  straightforward: 'Straightforward',
};

export const toolQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  no_tool: 'No Tools',
  tarot: 'Tarot',
  astrology: 'Astrology',
  numerology: 'Numerology',
  crystal: 'Crystals',
  oracle_card: 'Oracle cards',
  rune: 'Runes',
  i_ching: 'I-Ching',
  pendulum: 'Pendulum',
};

export const priceQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  4: '4',
  5: '5',
  '6_50': '6',
  '7_50': '7',
  '8_50': '9',
  10: '8',
  13: '2',
  15: '10',
  17: '11',
  20: '12',
  23: '13',
};

export const availabilityQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  chat: 'isChatPsychics',
  phone: 'isPhonePsychics',
  appointment: 'isAppointmentPsychics',
  offline_message: 'isDMPsychics',
};

export const popularQueryToApiMap: Partial<Record<PsychicCategoryQueryType, string>> = {
  elite_psychic: 'ElitePsychics',
  new_psychic: 'NewPsychics',
  customer_favorite: 'CustomerFavorite',
  staff_pick: 'StaffPick',
  rising_star: 'RisingStars',
};

export const queryParamToRequestParamMap: Omit<QueryParamToRequestParamMap, 'pf_availability'> = {
  pf_subject: 'Subject',
  pf_ability: 'Ability',
  pf_style: 'Style',
  pf_tool: 'Tool',
  pf_price: 'Price',
  pf_popular: 'Popular',
};

export const sortingQueryToApiMap: Record<SortingQueryValue, string> = {
  recommended: 'BestAvailable',
  price_low_high: 'LowPrice',
  price_high_low: 'HighPrice',
  star_rating: 'HighStarRating',
  rising_star: 'RisingStars',
  staff_pick: 'StaffPick',
  customer_favorite: 'CustomerFavorite',
  premier_psychic: 'ElitePsychics',
  new_psychic: 'NewPsychics',
  chat_psychic: 'ChatPsychics',
  experience: 'Experience',
  estimated_wait: 'EstimatedWaitTime',
};
